export default "__VITE_ASSET__DeVUxrR0__"